/* eslint-disable jsx-a11y/no-static-element-interactions, react/no-array-index-key */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { scroller } from 'react-scroll';

import {
  SITE_PLATFORM_MOBILE,
  SITE_PLATFORM_WEB_LARGE,
  SITE_PLATFORM_WEB,
  isMobileLandscape,
} from 'helpers/BreakpointHelper';

import makeSelectLivePanelsData from 'screens/Live/selectors';
import { MINUTES_INTERVAL, getStartingTs, isReturningVistor } from 'screens/Live/LiveHelpers';
import { now, stringToDate, isSameDay } from 'helpers/DateTimeHelper';

import EPGCurrentTimer from 'screens/Live/components/EPGCurrentTimer';
import EPGLoader from '../EPGLoader';
import EPGRow from '../EPGRow';
import EPGTimeline from '../EPGTimeline';

import Style from './EPGGrid.module.scss';

class EPGGrid extends Component {
  constructor(props) {
    super(props);
    this.currentTimerEnded = this.currentTimerEnded.bind(this);
    this.getSelectedDate = this.getSelectedDate.bind(this);
  }

  componentDidMount() {
    const { changeDate, setSelectedDate } = this.props;
    const selectedDate = this.getSelectedDate();
    const breakpointIsMobile = this.isMobile();

    changeDate(selectedDate);

    if (breakpointIsMobile) {
      setSelectedDate(now());
    }

    this.scrollToPreviousGridElement();
    const element = document.getElementById('live-page-overflow');
    element.addEventListener('scroll', this.syncScroll, { passive: true });
    window.addEventListener('resize', this.syncScroll, { passive: true });
  }

  componentDidUpdate(prevProps) {
    const { breakpoint: prevBreakpoint } = prevProps;
    const { breakpoint, setStartingTs } = this.props;
    if (prevBreakpoint !== breakpoint) setStartingTs(getStartingTs());
  }

  componentWillUnmount() {
    const element = document.getElementById('live-page-overflow');
    element.removeEventListener('scroll', this.syncScroll);
    window.removeEventListener('resize', this.syncScroll);
  }

  syncScroll = () => {
    const stickyHeight = document.querySelector('.stickyContainer').clientHeight;
    const panelContainer = document.querySelector('#panelContainer');
    const timeline = document.querySelector('.stickyTimeline');

    if (timeline) {
      const topStyle = this.isWeb() ? 90 : 55;
      timeline.style.top = `${stickyHeight + topStyle}px`;
    }

    if (window.innerWidth < 768) {
      if (panelContainer) panelContainer.style.overflowX = 'scroll';
      if (timeline) {
        timeline.style.overflowX = 'scroll';
        timeline.scrollLeft = panelContainer.scrollLeft;
        timeline.scrollTop = panelContainer.scrollTop;
      }
    } else {
      if (panelContainer) panelContainer.style.overflowX = 'visible';
      if (timeline) {
        timeline.style.overflowX = 'visible';
      }
    }
  };

  getSelectedDate() {
    const { selectedDate } = this.props;
    return selectedDate === null ? now() : stringToDate(selectedDate);
  }

  checkSameDay(date) {
    const selectedDate = this.getSelectedDate();
    return isSameDay(selectedDate, date);
  }

  currentTimerEnded() {
    const { setStartingTs, setStartingDate, setEpgGridPage, changeDate } = this.props;
    changeDate();
    setStartingTs(getStartingTs());
    setEpgGridPage(1);
    setStartingDate(now());
  }

  isWeb() {
    const { breakpoint } = this.props;
    return breakpoint === SITE_PLATFORM_WEB || breakpoint === SITE_PLATFORM_WEB_LARGE;
  }

  isMobile() {
    const { breakpoint } = this.props;
    return breakpoint === SITE_PLATFORM_MOBILE || isMobileLandscape();
  }

  scrollToPreviousGridElement() {
    const { prevRowIdx, location } = this.props;
    if (prevRowIdx && isReturningVistor(location)) {
      scroller.scrollTo(`${prevRowIdx}`, { duration: 300, offset: 0, smooth: true });
    }
  }

  renderPanels() {
    const { endingDate } = this.props;
    const {
      account,
      breakpoint,
      checkAtStarting,
      defaultProgram,
      epgGridPage,
      favoritesManager,
      globalVideo,
      gridStart,
      isAuthenticated,
      isStatic,
      location,
      overlay,
      panels,
      preauthorizedResources,
      saveLiveRestart,
      selectedChannel,
      selectedVideoData,
      setCurrentVideo,
      setOverlay,
      setSelectedDate,
      startingTs,
    } = this.props;

    const selectedDate = this.getSelectedDate();
    const breakpointIsMobile = window.innerWidth < 768;

    if (!panels || !panels.member || panels.length === 0) return null;
    return panels.member.map((item, rowIdx) => {
      const { callSign, id } = item;
      const EPGRowProps = {
        account,
        atStartDate: checkAtStarting(selectedDate),
        breakpoint,
        breakpointIsMobile,
        defaultProgram,
        endingDate,
        epgGridPage,
        favoritesManager,
        globalVideo,
        gridStart,
        isAuthenticated,
        isStatic,
        key: `${callSign}-${id}`,
        location,
        overlay,
        preauthorizedResources,
        row: item,
        rowIdx,
        saveLiveRestart,
        selectedChannel,
        selectedDate,
        selectedVideoData,
        setCurrentVideo,
        setOverlay,
        setSelectedDate,
        startingTs,
      };
      return <EPGRow {...EPGRowProps} />;
    });
  }

  render() {
    const {
      accessToken,
      breakpoint,
      checkAtStarting,
      coordinates,
      deviceId,
      endingDate,
      fetchLiveAction,
      panels,
      setSelectedDate,
      startingTs,
      setStartingTs,
    } = this.props;
    const breakpointIsMobile = this.isMobile();
    const selectedDate = this.getSelectedDate();
    const atStartDate = checkAtStarting ? checkAtStarting(selectedDate) : null;

    if (!panels) return <EPGLoader />;

    if (breakpointIsMobile) {
      setSelectedDate(now());
    }

    return (
      <section
        ref={ref => {
          this.epgWrapElement = ref;
        }}
        className={Style.epgWrap}
      >
        <div className={Style.scheduleGrid}>
          <div className={classNames(Style.timeline, 'stickyTimeline')} onScroll={this.syncScroll}>
            {atStartDate ? (
              <EPGCurrentTimer
                ended={this.currentTimerEnded}
                startingTs={startingTs}
                totalMinutes={MINUTES_INTERVAL}
              />
            ) : null}
            <EPGTimeline
              accessToken={accessToken}
              breakpoint={breakpoint}
              checkAtStarting={checkAtStarting}
              coordinates={coordinates}
              deviceId={deviceId}
              endingDate={endingDate}
              ended={this.currentTimerEnded}
              fetchLiveAction={fetchLiveAction}
              startingTs={startingTs}
              totalMinutes={MINUTES_INTERVAL}
              selectedDate={selectedDate}
              setStartingTs={setStartingTs}
            />
          </div>
          <div className={Style.panelContainer} id="panelContainer" onScroll={this.syncScroll}>
            {this.renderPanels()}
          </div>
        </div>
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    panels: makeSelectLivePanelsData(state),
    prevRowIdx: state.live?.prevRowIdx,
  };
}

EPGGrid.defaultProps = {
  account: {},
  breakpoint: null,
  changeDate: () => {},
  favoritesManager: null,
  isAuthenticated: null,
  isStatic: false,
  location: {},
  overlay: null,
  panels: null,
  preauthorizedResources: [],
  prevRowIdx: null,
  selectedChannel: 0,
  setSelectedDate: () => null,
  selectedDate: null,
  selectedVideoData: null,
  defaultProgram: null,
};

EPGGrid.propTypes = {
  accessToken: PropTypes.string,
  account: PropTypes.shape({}),
  breakpoint: PropTypes.string,
  changeDate: PropTypes.func,
  coordinates: PropTypes.shape({}),
  checkAtStarting: PropTypes.func,
  defaultProgram: PropTypes.string,
  deviceId: PropTypes.string,
  epgGridPage: PropTypes.number,
  endingDate: PropTypes.instanceOf(Date),
  favoritesManager: PropTypes.shape({
    favorites: PropTypes.arrayOf(PropTypes.shape({})),
    setFavorites: PropTypes.func,
    deleteFavorites: PropTypes.func,
  }),
  fetchLiveAction: PropTypes.func,
  globalVideo: PropTypes.func,
  gridStart: PropTypes.func,
  isAuthenticated: PropTypes.bool,
  isStatic: PropTypes.bool,
  location: PropTypes.shape({}),
  overlay: PropTypes.string,
  panels: PropTypes.shape({
    itemsPerPage: PropTypes.number,
    member: PropTypes.arrayOf(PropTypes.shape({})),
    totalItems: PropTypes.number,
  }),
  preauthorizedResources: PropTypes.arrayOf(PropTypes.string),
  prevRowIdx: PropTypes.number,
  saveLiveRestart: PropTypes.func,
  selectedChannel: PropTypes.number,
  selectedDate: PropTypes.instanceOf(Date),
  selectedVideoData: PropTypes.shape({}),
  setEpgGridPage: PropTypes.func,
  setOverlay: PropTypes.func,
  setSelectedDate: PropTypes.func,
  setStartingDate: PropTypes.func,
  setStartingTs: PropTypes.func,
  setCurrentVideo: PropTypes.func,
  startingTs: PropTypes.number,
};

export default React.memo(connect(mapStateToProps)(EPGGrid));
